import { Button } from '@change/ds-core-ui';

import { usePageFooter } from './hooks/usePageFooter';

export function PageFooter() {
	const {
		data: { skipLabel, skipUrl },
		actions: { handleSkipClick },
	} = usePageFooter();

	return (
		<div className="px-4 py-7 text-center md:mt-5">
			<Button
				as="a"
				href={skipUrl}
				onClick={handleSkipClick}
				data-qa="skip-link"
				variant="tertiary"
				size="large"
				className="self-center"
			>
				{skipLabel}
			</Button>
		</div>
	);
}
